import React from 'react';
import { Box } from 'rebass';
import { Input } from '@rebass/forms';
import { FiSearch } from 'react-icons/fi';

/**
 * Search input component.
 *
 * @param {Omit<React.InputHTMLAttributes<HTMLInputElement>>} props
 * @param {React.Ref<HTMLInputElement>} ref
 */
export default React.forwardRef(
    /**
     * @param {React.InputHTMLAttributes<HTMLInputElement>} props
     * @param {boolean} props.[displayHidden]
     * @param {string} props.[rootClassName]
     * @param {React.Ref<HTMLInputElement>} ref
     */
    ({ displayHidden, rootClassName, autoFocus, placeholder, ...rest }, ref) => (
        <Box
            className={rootClassName}
            style={{ position: 'relative', height: '32px', display: displayHidden ? 'none' : 'block' }}
        >
            <Input
                ref={ref}
                {...rest}
                style={{ padding: '6px 0px 6px 36px' }}
                type="text"
                className="input-darker"
                placeholder={placeholder && 'Search'}
            />
            <FiSearch
                className="text-primary"
                style={{
                    position: 'absolute',
                    left: '12px',
                    top: '8px',
                    strokeWidth: '1.5px',
                    fontSize: '16px'
                }}
            />
        </Box>
    )
);
